import React from "react";
import ColorSwatches from "./ColorSwatches";
import "./color-palette.styles.scss";
// Existing text/highlight toolbar calls retain their placement and selection.
export default function ColorPalette({ embedded = false, ...props }) {
  return <div className={embedded ? "" : "ant-editor-palette"}>
    <ColorSwatches columns={10} size={32} preserveSelection {...props} />
  </div>;
}
